<template>
    <ul class="langage-select">
        <li v-for="(lang, index) in languages">
            <a
                href="javascript:;"
                :class="{ active: active_lang === index }"
                @click="active_lang = index"
            >
                {{ lang.name }}
            </a>
        </li>
    </ul>
    <section class="container-translated">
        <section v-for="(lang, index) in languages">
            <Transition>
                <section v-if="active_lang == index">
                    <FormKitSchema :schema="schema[index]" />
                </section>
            </Transition>
        </section>
    </section>
</template>

<script setup>
import { ref, computed } from "vue";
import { usePage } from "@inertiajs/inertia-vue3";
const props = defineProps({
    schema: Array,
});

const i18n = computed(() => usePage().props.value.config.i18n);
const languages = i18n.value.languages;

const language_keys = Object.keys(languages);

const active_lang = ref(language_keys[0]);

const schema = [];

for (const key in languages) {
    schema[key] = [];

    props.schema.forEach((element, i) => {
        let el = Object.assign({}, element, {
            label: element.label + " (" + key.toUpperCase() + ")",
            name: "_translations." + languages[key].locale + "." + element.name,
            value: "",
        });

        schema[key].push(el);
    });
}
</script>

<style lang="scss" scoped>
.langage-select {
    display: flex;
    align-items: bottom;
    margin: 0 0 2rem 0;
    padding: 0;
    list-style: none;
    background-color: #f0f0f0;
    padding: 4px 4px 0 4px;
    li {
        margin-bottom: 0;
        display: block;
    }
    li:not(:last-child) {
        margin-right: 1rem;
    }

    a {
        background-color: #f0f0f0;
        padding: 0.5rem 1rem;
        display: block;

        &.active {
            background: #fff;
        }
    }
}

.container-translated {
    overflow: hidden;
    margin-bottom: 0;
    section {
        margin-bottom: 0;
    }
}
.slide-enter-active,
.slide-leave-active {
    transition: all 0.2s ease-out;
}
.slide-enter-to {
    transform: translateX(0);
}
.slide-enter-from {
    transform: translateX(100%);
}
.slide-leave-to {
    transform: translateX(-100%);
}
.slide-leave-from {
    // position: absolute;
    // left: 0;
    transform: translateX(0);
}
</style>
